import React, { useEffect, useState } from 'react'
import { useServerAPI } from '../Session';
import { Paper, Typography } from '@mui/material';
import { DataGridPro as DataGrid, GridActionsCellItem, GridColDef, GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import SecurityIcon from '@mui/icons-material/Security';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useAuth } from '../Authentication';
import { CommonToolbar } from '../components/CommonToolbar';

function AerodromesListPage() {

    const [loading,setLoading] = useState(false);
    const [customers, setCustomers] = useState<any[]>();
    const [customerCount, setCustomerCount] = useState(-1);
    const [paginationModel, setPaginationModel] = React.useState<GridPaginationModel>({
        pageSize: 25,
        page: 0,
    });
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: []
    })
    const [sortModel, setSortModel] = React.useState<GridSortModel>();
    const { userData } = useAuth();
    
    const server = useServerAPI();


    const columns: GridColDef[] = [
        {
            field: 'data.ICAO_Code',
            valueGetter: (v, r) => {
                return r?.data.ICAO_Code
            },
            headerName: 'ID',
            width: 90
        },
        {
            field: 'data.Aerodrome_Name',
            valueGetter: (v, r: any) => r?.data.Aerodrome_Name,
            headerName: 'Name',
            flex: 2
            //   editable: true,
        },
        {
            field: 'data.Province',
            valueGetter: (v, r: any) => r?.data.Province,
            headerName: 'Province',
            width: 150,
            //   editable: true,
        },
        {
            field: 'data.Country',
            valueGetter: (v, r: any) => r?.data.Country,
            headerName: 'Country',
            flex: 1
            //   editable: true,
        },
        {
            field: 'data.North_of_60',
            valueGetter: (v, r: any) => r?.data["North_of_60°"] === "1",
            type:'boolean',
            headerName: 'North_of_60',
            width: 160,
        },
        {
            field: 'data.Terminal_Fee',
            valueGetter: (v, r: any) => r?.data.Terminal_Fee === "1",
            headerName: 'Terminal_Fee',
            type:'boolean',
            width: 160,
        },
        {
            field: 'data.Radius_Reduction',
            valueGetter: (v, r: any) => r?.data.Radius_Reduction,
            headerName: 'Radius_Reduction',
            width: 160,
        },
        {
            field: 'actions',
            type: 'actions',
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<EditIcon />}
                    label="Edit"
                    // onClick={handleEditCustomer(params.row.entityId)}
                />,
                <GridActionsCellItem
                    icon={<SecurityIcon />}
                    label="Other Action"
                    // onClick={toggleAdmin(params.id)}
                    showInMenu
                />,
                <GridActionsCellItem
                    icon={<FileCopyIcon />}
                    label="Other Other Action"
                    // onClick={duplicateUser(params.id)}
                    showInMenu
                />,
            ],
        },
    ];

    const handleFilterModelChange = (filterModel: GridFilterModel) => {
        console.debug(`filterModel`, filterModel);
        setCustomerCount(-1);
        setFilterModel(filterModel);
    }
    const handleSortModelChange = (newsortModel: GridSortModel) => {
        console.debug(`filterModel`, newsortModel);
        setSortModel(newsortModel);
    }

    useEffect(() => {
        if (customerCount === -1) {
            server.countAerodrome(filterToSearchCriteria(filterModel)).then(r => {
                if (typeof r === 'number') {
                    setCustomerCount(r);
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterModel]);

    useEffect(() => {
        if (!loading) {
            setLoading(true);
            server.listAerodrome(paginationModel.pageSize, paginationModel.page + 1, filterToSearchCriteria(filterModel), sortToSortCriteria(sortModel)).then(r => {
                if (r) {
                    if (Array.isArray(r)) {
                        setCustomers(r);
                        console.log(`Got customer list ${r.length}`);
                    }
                }
                setLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, filterModel, sortModel])

    React.useEffect(()=>{
        if (userData?.authPayload?.Customer_Number) {
            
        }
    },[userData])

    const filterToSearchCriteria = (filters: GridFilterModel) => {
        var searchCriteria: { [prop: string]: any } = {};
        for (const filter of filters.items) {
            switch (filter.operator) {
                case "contains":
                    searchCriteria[filter.field] = { "$regex": `${filter.value}` };
                    break;
                case "equals":
                    searchCriteria[filter.field] = filter.value;
                    break;
                case "startsWith":
                    searchCriteria[filter.field] = { "$regex": `^${filter.value}` };
                    break;
                case "endsWith":
                    searchCriteria[filter.field] = { "$regex": `${filter.value}$` };
                    break;
                case "isEmpty":
                    searchCriteria[filter.field] = { "$exists": false };
                    break;
                case "isNotEmpty":
                    searchCriteria[filter.field] = { "$exists": true };
                    break;
                case "isAnyOf":
                    searchCriteria[filter.field] = { "$in": filter.value };
                    break;

                default:
                    break;
            }
        }
        if (userData?.authPayload?.Customer_Number) {
            // if the user has a set customer then force it.
            searchCriteria["data.Customer_Number"] = userData?.authPayload?.Customer_Number;   
        }
        return searchCriteria;
    }

    const sortToSortCriteria = (sortList?: GridSortModel) => {
        var sortCriteria: { [prop: string]: any } = {};
        if (sortList) {
            for (const sort of sortList) {
                sortCriteria[sort.field] = sort.sort === 'asc' ? 1 : -1;
            }
        }
        return sortCriteria;
    }

    return (
        <Paper elevation={1} sx={{ margin: '20px' }}>
            <Typography variant='h5'>Aerodromes</Typography>            
            <DataGrid
                slots={{ toolbar: CommonToolbar }}
                loading={loading}
                pagination
                rows={customers ?? []}
                getRowId={(r) => r.entityId}
                columns={columns}
                rowCount={customerCount}
                paginationMode='server'
                onFilterModelChange={handleFilterModelChange}
                filterModel={filterModel}
                filterMode='server'
                onPaginationModelChange={setPaginationModel}
                paginationModel={paginationModel}
                sortingMode='server'
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                // autoPageSize
                autoHeight
                // pageSizeOptions={[5,10,20]}
            />
        </Paper>
    )
}

export default AerodromesListPage 